export default function getStripeProductMaxQuantity(stripeProduct, seatsQty) {
  seatsQty ||= Infinity
  // NOTE: `stripeProduct.max_quantity` may be null.
  return stripeProduct.max_quantity
    ? Math.min(seatsQty, stripeProduct.max_quantity)
    : seatsQty
}
